// Mock data for Owaza Martial Arts website

export const businessInfo = {
  name: "Owaza Martial Arts",
  address: "14726 County Line Rd, Spring Hill, FL 34610",
  // phone            = Owaza office line (primary public contact)
  // direct_line_phone = Hanshi Jim Rivera's personal/direct line
  phone: "(352) 428-0086",
  direct_line_phone: "(352) 428-0086",
  direct_line_label: "Hanshi Jim Rivera's direct line",
  email: "info@owazamartialarts.com",
  hours: {
    monday: { open: "17:30", close: "19:30" },
    tuesday: { open: "17:30", close: "19:30" },
    wednesday: { open: "17:30", close: "19:30" },
    thursday: { open: "17:30", close: "19:30" },
    friday: { open: "TBA", close: "TBA" },
    saturday: "Closed",
    sunday: "Closed"
  }
};

export const schedule = {
  timezone: "America/New_York",
  location: "14726 County Line Rd, Spring Hill, FL 34610",
  phone: "+1-352-428-0086",
  week: {
    monday: [
      { name: "Youth Class", start: "17:30", end: "18:30" },
      { name: "Male Adult Class", start: "18:30", end: "19:30" }
    ],
    tuesday: [
      { name: "Female Adult Class", start: "17:30", end: "18:30" },
      { name: "Youth Class", start: "18:30", end: "19:30" }
    ],
    wednesday: [
      { name: "Youth Class", start: "17:30", end: "18:30" },
      { name: "Male Adult Class", start: "18:30", end: "19:30" }
    ],
    thursday: [
      { name: "Female Adult Class", start: "17:30", end: "18:30" },
      { name: "Youth Class", start: "18:30", end: "19:30" }
    ],
    friday: [
      { name: "Weekend Warrior Flow", note: "Open mat / conditioning; time announced on Events page" }
    ]
  }
};

export const programs = [
  {
    id: 1,
    title: "Kids (Ages 4-6)",
    description: "Fun, foundational martial arts for our youngest students. Focus on balance, coordination, and basic techniques through engaging games and activities.",
    ageRange: "4-6 years",
    features: ["Basic techniques", "Coordination skills", "Fun games", "Character building"],
    image: "https://d598mmm7zleni.cloudfront.net/images/kids.jpg"
  },
  {
    id: 2,
    title: "Youth (Ages 7-12)",
    description: "Structured martial arts training that builds confidence, discipline, and practical self-defense skills for school-age children.",
    ageRange: "7-12 years",
    features: ["Self-defense", "Discipline", "Confidence", "Fitness"],
    image: "https://d598mmm7zleni.cloudfront.net/images/youth.jpg"
  },
  {
    id: 3,
    title: "Teens & Adults",
    description: "Comprehensive martial arts training combining traditional techniques with modern self-defense applications for real-world situations.",
    ageRange: "13+ years",
    features: ["Advanced techniques", "Physical fitness", "Mental discipline", "Real-world application"],
    image: "https://d598mmm7zleni.cloudfront.net/images/adults.png"
  },
  {
    id: 4,
    title: "Women's Self-Defense (CAT)",
    description: "Certified CAT (Children's Assault Treatment) self-defense program specifically designed for women's safety and empowerment.",
    ageRange: "Women only",
    features: ["CAT certified", "Women-focused", "Practical techniques", "Empowerment"],
    image: "https://d598mmm7zleni.cloudfront.net/images/womens.jpg"
  }
];

export const whyOwaza = [
  {
    title: "Appointment-Only Training",
    description: "Focused, personalized attention with no distractions from spectators. Every session is intentional and productive.",
    icon: "Calendar"
  },
  {
    title: "Certified CAT System",
    description: "Official Children's Assault Treatment program providing proven self-defense techniques for real-world situations.",
    icon: "Shield"
  },
  {
    title: "Adult Background Checks",
    description: "Enhanced safety measures for all adult memberships with professional background check verification.",
    icon: "UserCheck"
  },
  {
    title: "Expert Instruction",
    description: "Experienced instructors dedicated to your personal growth and martial arts journey.",
    icon: "Award"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    rating: 5,
    text: "Owaza has transformed my daughter's confidence. The instructors are amazing and the appointment-only format means she gets the attention she needs.",
    program: "Youth Program"
  },
  {
    id: 2,
    name: "Mike Chen",
    rating: 5,
    text: "Best martial arts studio I've been to. The CAT system is incredibly practical and the adult background checks give me peace of mind.",
    program: "Adult Program"
  },
  {
    id: 3,
    name: "Lisa Martinez",
    rating: 5,
    text: "The women's self-defense program has been life-changing. I feel so much more confident and prepared now.",
    program: "Women's Self-Defense"
  },
  {
    id: 4,
    name: "David Thompson",
    rating: 5,
    text: "Professional, focused, and effective training. The appointment system eliminates all distractions.",
    program: "Adult Program"
  },
  {
    id: 5,
    name: "Jennifer Lee",
    rating: 5,
    text: "My son loves his classes here. The instructors are patient and skilled at working with kids.",
    program: "Kids Program"
  },
  {
    id: 6,
    name: "Robert Wilson",
    rating: 5,
    text: "Excellent martial arts instruction with a focus on practical application. Highly recommend!",
    program: "Adult Program"
  }
];

export const expectationSteps = [
  {
    step: 1,
    title: "Book Your Intro Appointment",
    description: "Call us or click to schedule your 2-Week QuickStart session for just $45. We'll discuss your goals and answer any questions."
  },
  {
    step: 2,
    title: "Complete Background Check",
    description: "Adult memberships require a completed background check for everyone's safety. We'll guide you through this simple process."
  },
  {
    step: 3,
    title: "Start Your Training Journey",
    description: "Begin your martial arts journey in our focused, appointment-only environment with expert instruction tailored to your needs."
  }
];

export const trustIndicators = [
  "As seen on News 8, 9 & 10",
  "Certified CAT Self-Defense",
  "★★★★★ Google-Rated"
];